<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-lg" role="document">
      <div v-if="selectedBill" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{
              selectedBill.apply_charges ?
                'Descontar encargos da mensalidade atrasada' :
                'Reabilitar encargos da mensalidade atrasada'
            }}
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Id</th>
                <td>{{ selectedBill.id }}</td>
              </tr>
              <tr>
                <th>Data de vencimento</th>
                <td>{{ selectedBill.due_date | formatDate }}</td>
              </tr>
              <tr>
                <th>Valor</th>
                <td>{{ selectedBill.amount | formatCurrency }}</td>
              </tr>
              <tr>
                <th>Valor com encargos</th>
                <td>{{ selectedBill.amount_with_charges | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="discountChargesError" class="alert alert-danger">
              {{ discountChargesError }}
            </div>
            <p v-if="selectedBill.apply_charges">
              Este processo irá isentar esta mensalidade de encargos por atraso, como juros e multa.
            </p>
            <p v-else>
              Os encargos já foram isentados para esta mensalidade.
              Este processo irá reabilitar os encargos, cancelar os pagamentos desta mensalidade e gerar um novo.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="applyChargesDisableOrEnable"
          >
            Aplicar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      discountChargesError: null,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    applyChargesDisableOrEnable() {
      if (this.selectedBill.apply_charges) {
        this.disableCharges();
      } else {
        this.enableCharges();
      }
    },
    disableCharges() {
      this.$loader.show();
      BillsService.disableCharges(this.selectedBill.id)
        .then((response) => {
          this.$emit('close');
          this.loadStudentBills();
          this.$alert.notifySuccess(response.message);
        })
        .catch((error) => {
          this.$loader.hide();
          this.discountChargesError = `Erro ao desabilitar os encargos: ${error.body.message}`;
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
    enableCharges() {
      this.$loader.show();
      BillsService.enableCharges(this.selectedBill.id)
        .then((response) => {
          this.$emit('close');
          this.loadStudentBills();
          this.$alert.notifySuccess(response.message);
        })
        .catch(({ body }) => {
          this.discountChargesError = `Erro ao reabilitar os encargos: ${body.message}`;
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
